
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import TextBox from './../../zviz2/zviz/components/textbox';
import Rectangle from './../../zviz2/zviz/components/rectangle';
import PanelBlueprint from './../elements/panel';
import ActiveFilter from './active';
import {extend, cloneObject, trimLowerCase, createObjectFromData} from './../../zviz2/zviz/functions';
import filterModel from './../../model/filter';
import {styleText} from './../../styles';
import config from './../../config';
import BlueprintLoader from './../elements/loader';

//import {LifeCycle} from './../zviz2/zviz/cycle';

class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.options = [];
        this.elementSet = false;
        this.dataLoaded = false;
        this.sliderInitialized = false;
        this.more = 0;

        this.filterField = '';
        this.filterName = '';

        this.isLoading = true;

    }

    init(renderer){
        super.init(renderer);
        this.filterField = this.data.dimensions[0];
        this.filterName = config.data.dimensionTitles[this.filterField];
        this.data.name = this.filterField;

        this.checkDimension();

    }

    checkDimension(){

        let dimTheme = this.data.dimensions[0];
        let t = state.get('filter.'+this.data.dimensions[1]);
        let tc = state.get('filter.' + this.data.dimensions[0]);
        if(t || tc){
            dimTheme = this.data.dimensions[1];
        }
        if(dimTheme != this.filterField){
            this.filterField = dimTheme;
            this.filterName = config.data.dimensionTitles[this.filterField];
        }
        this.data.name = this.filterField;
        // this.update();

    }


    loadData(){
        this.checkDimension();
        this.isLoading = false;
        let status = this.models['filter'].status;
        if(status == 'success'){
            let data = this.models['filter'].data[this.data.name];
            this.options = [];
            this.more = 0;
            if(data != null){
                for(var x = 0; x < data.length; x++){
                    this.options.push(data[x]);
                    if(x > 8){
                        this.more = data.length - 10;
                        break;
                    }
                }
            }
        }else if(status == 'loading'){
            this.isLoading = true;
        }else if(status == 'failed'){
            this.isLoading = false;
            state.set('errorMessage', {title: 'Error loading themes', description: this.data} );
        }
    }

    getChildren(){
        this.loadData();
        if(this.options.length == 0){
            return cloneObject(BlueprintNoItems);
        }
        let result = [];

        let source = state.get('source');
        let sourceName = config.data.sourceTitles[source];

        if(sourceName.length < 12){
            sourceName = 'Number of ' + sourceName;
        }else{
            sourceName = sourceName.substring(0,1).toUpperCase() + 
                    sourceName.substring(1);
        }

        result.push(extend({
            properties: { 
                data: {
                    name: this.filterName,
                    value: sourceName,
                    isHeader: true
                }
            }
        }, BlueprintThemeItem));

        let max = 0;
        for(let o of this.options){
            o.a = parseInt(o.a, 10);
            if(o.a > max){
                max = o.a;
            }
        }
        let i = 0;
        for(let o of this.options){
            result.push(extend({
                properties: { 
                    data: {
                        name: o.v,
                        value: o.a,
                        percent: (o.a / max),
                        index: i
                    }
                }
            }, BlueprintThemeItem));
            i++;
        }
        return result;
    }

    getMore(){
        if(this.more == 0){
            return [];
        }
        return extend({
            properties: {
                style: extend({
                    fontSize: '9pt',
                    marginTop: '10px'
                }, styleText),
                content: '...and ' + this.more + ' more items'
            }
        }, TextBox);
    }

}


class ThemeItemController extends GroupController{

    constructor(parent, blueprint={}){
        super(parent, blueprint);
    }

    getColor(){
        const source = state.get('source');
        const themeDim = source === 'eval' || source === 'planned' ? 'theme' : source + '_theme';
        let tc = 'other';
        if(this.data.isHeader){
            return 'transparent';
        }
        if(this.parent.filterField == themeDim + '_category'){
            tc = this.data.name;
        }else if(this.parent.filterField == themeDim){
            let stc = state.get('filter.' + themeDim + '_category');
            if(stc){
                if(stc instanceof Array){
                    tc = (stc.length > 1)? 'unknown': stc[0];
                }else{
                    tc = stc;
                }
            }else{
                let filterModel = this.models['filter'];
                if(filterModel.result[themeDim + '_category'] && 
                        filterModel.result[themeDim + '_category'].length == 1){
                    let ftc = createObjectFromData(filterModel.result[themeDim + '_category'][0], 
                            {v: ['v', '[unknown]'], a: ['a', 0]});
                    tc = ftc.v;
                }
            }
        }else{
            tc = 'default';
        }

        let hsl = config.display.themeColors['other'];
        if(config.display.themeColors[trimLowerCase(tc)]){
            hsl = config.display.themeColors[trimLowerCase(tc)].slice(0);
        }

        return 'hsl('+hsl[0]+','+hsl[1]+'%,'+hsl[2]+'%)'; 

    }

    onItemClick(event){

        let name = this.parent.filterField;

        let filter = state.get('filter.' + name);

        if(! filter){
            filter = [];
        }
        if(! (filter instanceof Array)){
            filter = [filter];
        }
        for(let i = 0; i < filter.length; i++){
            if(filter[i] == this.data.name){
                filter.splice(i, 1);
                if(filter.length == 0){
                    filter = null;
                }
                state.set('filter.'+name, filter);
                return;
            }
        }
        filter.push(this.data.name);

        state.set('filter.'+name, filter);
    }

    isActive(checkFilterPresent=false){

        let val = state.get('filter.'+this.parent.filterField);
        if(! val){
            return ! checkFilterPresent;
        }
        if(! (val instanceof Array)){
            val = [val];
        }
        for(let f of val){
            if(f == this.data.name){
                return true
            }
        }
        return false;
    }

    

}



let Blueprint = extend({
    properties: {
        data: {
            name: 'region',
            title: 'Region',
            dimensions: ['region', 'country']
        }
    },
    private: {
        children: [
            extend({
                listeners: [
                    (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'filter') ),
                    (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'source') )
                ],
                properties:{
                    data: {filter: (ctrl) => (ctrl.parent.data.dimensions[0])}
                }
            }, ActiveFilter),

            extend({
                type: Controller,
                models: {
                    'filter': null
                },
                listeners: [
                    (ctrl) => ( ctrl.addListener(ctrl.models['filter'], [ctrl, ctrl.update]) ),
                    (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'filter') )
                ],
                properties: {
                    style: extend({ 
                        fontSize: '8pt',
                        position: 'relative',
                        width: '100%'   // not sure why, but if I don't set the widht, it will use the width of parent ellement...
                    }, styleText),
                    data: {
                        name: (ctrl) => (ctrl.parent.data.name),
                        dimensions: (ctrl) => (ctrl.parent.data.dimensions)
                    }
                },
                events: {  },
                children: [ 
                    (ctrl) => ( ctrl.getChildren() ),
                    (ctrl) => ( ctrl.getMore() ),
                    (ctrl) => ( ctrl.isLoading? cloneObject(BlueprintLoader): [] )
                ]
            }, Group)
        ]
    }
}, PanelBlueprint);

let BlueprintNoItems = extend({
    properties: {
        style: extend({
                fontStyle: 'italic'
            }, styleText),
        content: 'No items'
    }
}, TextBox);

let BlueprintThemeItem = extend({
    type: ThemeItemController,
    models: {
        'filter': null
    },
    properties:{
        style: {
            backgroundColor: (ctrl) => ( ctrl.data.isHeader? '#f7f6f5': 'white'),
            height: (ctrl) => ( (ctrl.data.index == 0 )? '27px': '20px'),
            cursor: 'pointer',
            opacity: (ctrl) => ( ctrl.data.isHeader? '1': (ctrl.isActive()? '1': '0.35') )
        }
    },
    events: {
        click: (event, ctrl) => { ctrl.onItemClick(event); }
    },
    children: [
        (parent) => (extend({
            properties: {
                style: {
                    fontStyle: (parent.data.isHeader? 'italic': 'normal' ),
                    textAlign: 'right',
                    width: '47%',
                    marginRight: '3%',
                    display: 'inline-block',
                    lineHeight: '20px',
                    paddingTop: (ctrl) => ( (ctrl.parent.data.index == 0 )? '7px': '0px' ),
                    height: '20px',
                    overflow: 'hidden',
                    background: (parent.data.isHeader? 'transparent': 
                            (parent.isActive(true) ? 
                                'transparent url(\'' + config.imgPath + 'delete_filter_small.png\') left top no-repeat': 
                                'transparent'))
                },
                content: parent.data.name
            }
        }, TextBox) ),
        
        (parent) => (extend({
            properties: {
                style: { 
                    position: 'relative',
                    width: '49%',
                    overflow: 'hidden',
                    display: 'inline-block',
                    borderLeft: '1px solid #d3d3d3',
                    height: (parent.data.index == 0 )? '27px': '20px',
                }, 
                data: cloneObject(parent.data)
            },
            children: [
                extend({
                    properties: {
                        position: {x: 7, y: (parent.data.index == 0 ? 11: 4) },
                        style: {
                            position: 'absolute',
                            height: '5px',
                            backgroundColor: (parent.getColor()),
                            width: (parent.data.isHeader? '0px': 
                                    Math.round(70*parent.data.percent) + 'px' ),
                        }
                    }
                }, Rectangle),

                extend({
                    properties: {
                        style: {
                            color: (parent.data.isHeader? '': '#848484' ),
                            fontStyle: (parent.data.isHeader? 'italic': 'normal' ),
                            textAlign: 'right',
                            top: '0px',
                            right: '0px',
                            display: 'block',
                            position: 'absolute',
                            lineHeight: '20px',
                            paddingTop: (parent.data.index == 0 ? '7px': '0px' ),
                        },
                        content: parent.data.value
                    }
                }, TextBox)
            ]
        }, Group) )
    ]
}, Group);

export default Blueprint;
export {Controller, Blueprint};
